<script setup lang="ts"></script>

<template>
  <span
    class="rounded-full bg-skin-text px-2 text-center text-xs leading-5 text-white"
  >
    <slot />
  </span>
</template>
